import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=3d437f8c&lang=pug&"
import script from "./Development.vue?vue&type=script&lang=ts&"
export * from "./Development.vue?vue&type=script&lang=ts&"
import style0 from "./Development.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports